/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoUpdateShipmentInput = {
    clientMutationId?: string | null;
    slug: string;
    shipmentKey: string;
    containerSlug: string;
    profileImageSlug?: string | null;
    shipmentType: string;
    vin?: string | null;
    description: string;
    weight?: number | null;
    parentShipment?: string | null;
    dischargeDate?: string | null;
    shipperReleaseCheck?: boolean | null;
    runs?: boolean | null;
    finalReleaseCheck?: boolean | null;
    atbPosition?: string | null;
    customsType?: string | null;
    customsReference?: string | null;
    vinEngine?: string | null;
    vinFuelType?: string | null;
    vinBodyClass?: string | null;
    vinOrigin?: string | null;
    linkedContacts: Array<LinkedContactInput>;
    deliveryLocation?: string | null;
};
export type LinkedContactInput = {
    role: string;
    contactSlug: string;
};
export type AddShipmentLinkedContactsMutationVariables = {
    input: infoUpdateShipmentInput;
};
export type AddShipmentLinkedContactsMutationResponse = {
    readonly infoUpdateShipment: {
        readonly shipment: {
            readonly slug: string;
        };
    } | null;
};
export type AddShipmentLinkedContactsMutation = {
    readonly response: AddShipmentLinkedContactsMutationResponse;
    readonly variables: AddShipmentLinkedContactsMutationVariables;
};



/*
mutation AddShipmentLinkedContactsMutation(
  $input: infoUpdateShipmentInput!
) {
  infoUpdateShipment(input: $input) {
    shipment {
      slug
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddShipmentLinkedContactsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoUpdateShipmentPayload",
        "kind": "LinkedField",
        "name": "infoUpdateShipment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Shipment",
            "kind": "LinkedField",
            "name": "shipment",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddShipmentLinkedContactsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoUpdateShipmentPayload",
        "kind": "LinkedField",
        "name": "infoUpdateShipment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Shipment",
            "kind": "LinkedField",
            "name": "shipment",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "427fd8a24d4f1bf92cbfee07264c1720",
    "id": null,
    "metadata": {},
    "name": "AddShipmentLinkedContactsMutation",
    "operationKind": "mutation",
    "text": "mutation AddShipmentLinkedContactsMutation(\n  $input: infoUpdateShipmentInput!\n) {\n  infoUpdateShipment(input: $input) {\n    shipment {\n      slug\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '6764bedfc4cc5ed15ea55af1c92551e9';
export default node;
